import { c as _c } from "react/compiler-runtime";
import { useProjectApiClient } from "@api/project-api/use-project-api-client";
import { ExportDropdown } from "@components/common/export/export-dropdown";
import { ProjectLaunchTarget } from "@custom-types/sdb-company-types";
import { addIElements } from "@faro-lotv/project-source";
import { useDateTime } from "@hooks/use-date-time";
import { useMembers } from "@hooks/use-members";
import { worldTransformCacheSelector } from "@store/i-elements/i-elements-selectors";
import { markupsSelector } from "@store/markups/markups-selector";
import { defaultProjectLaunchTargetSelector } from "@store/sdb-company/sdb-company-selector";
import { userSettingsSelector } from "@store/settings/settings-selector";
import { store } from "@store/store";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { downloadMarkupData } from "@utils/file-data-export";
import { TableType } from "@utils/track-event/track-event-list";
import { useCallback } from "react";
/** Dropdown to export markups in the file format selected by the user */
export function BulkExportMarkups(t0) {
  const $ = _c(24);
  const {
    projectId,
    markupIds,
    projectName,
    areEntitiesSelected,
    buttonType: t1
  } = t0;
  const buttonType = t1 === undefined ? "bulk" : t1;
  const {
    companyMembers,
    projectMembers
  } = useMembers();
  const projectLaunchSettings = useAppSelector(defaultProjectLaunchTargetSelector);
  const {
    formatDate
  } = useDateTime();
  let t2;
  if ($[0] !== projectId) {
    t2 = {
      projectId
    };
    $[0] = projectId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const projectApiClient = useProjectApiClient(t2);
  const dispatch = useAppDispatch();
  const userSettings = useAppSelector(userSettingsSelector);
  const unitMeasurement = userSettings.unit_measurement?.value ?? "meters";
  let t3;
  if ($[2] !== projectLaunchSettings.defaultOpenProjectTarget) {
    t3 = markup => {
      let openTarget = ProjectLaunchTarget.sphereViewer;
      if (projectLaunchSettings.defaultOpenProjectTarget === ProjectLaunchTarget.webEditor && markup?.webEditorUrl) {
        openTarget = projectLaunchSettings.defaultOpenProjectTarget;
      }
      return openTarget === ProjectLaunchTarget.sphereViewer ? markup.sphereViewerUrl : markup.webEditorUrl;
    };
    $[2] = projectLaunchSettings.defaultOpenProjectTarget;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const markupHref = t3;
  let t4;
  if ($[4] !== dispatch || $[5] !== projectApiClient) {
    t4 = async (markupIds_0, options) => {
      const ancestors = await projectApiClient.getAllIElements({
        descendantIds: markupIds_0,
        signal: options?.signal
      });
      dispatch(addIElements(ancestors));
    };
    $[4] = dispatch;
    $[5] = projectApiClient;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const fetchMarkupsAdditionalData = t4;
  let t5;
  if ($[7] !== companyMembers || $[8] !== fetchMarkupsAdditionalData || $[9] !== formatDate || $[10] !== markupHref || $[11] !== markupIds || $[12] !== projectMembers || $[13] !== projectName || $[14] !== unitMeasurement) {
    t5 = async (format, options_0) => {
      await fetchMarkupsAdditionalData(markupIds, options_0);
      if (options_0?.signal?.aborted) {
        return null;
      }
      const updatedMarkups = new Map(markupsSelector(store.getState()).map(_temp));
      const selectedMarkups = markupIds.map(markupId => updatedMarkups.get(markupId)).filter(_temp2);
      const worldTransformCache = worldTransformCacheSelector(store.getState());
      return await downloadMarkupData({
        markups: selectedMarkups,
        companyMembers,
        projectMembers,
        fileName: `${projectName}-Annotation List`,
        markupHref,
        formatDate,
        format,
        worldTransformCache,
        unitMeasurement
      });
    };
    $[7] = companyMembers;
    $[8] = fetchMarkupsAdditionalData;
    $[9] = formatDate;
    $[10] = markupHref;
    $[11] = markupIds;
    $[12] = projectMembers;
    $[13] = projectName;
    $[14] = unitMeasurement;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const exportHandler = t5;
  let t6;
  if ($[16] !== areEntitiesSelected || $[17] !== markupIds.length) {
    t6 = {
      dataType: TableType.projectMarkups,
      numberOfEntities: markupIds.length,
      areEntitiesSelected
    };
    $[16] = areEntitiesSelected;
    $[17] = markupIds.length;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      success: "Successfully exported annotations.",
      error: "Cannot export annotations. Please try again."
    };
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== buttonType || $[21] !== exportHandler || $[22] !== t6) {
    t8 = <ExportDropdown trackingProps={t6} exportHandler={exportHandler} toastMessage={t7} buttonTooltipText="Export annotations" buttonType={buttonType} shouldShowExportAllDialog={true} />;
    $[20] = buttonType;
    $[21] = exportHandler;
    $[22] = t6;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}
function _temp2(markup_1) {
  return markup_1 !== undefined;
}
function _temp(markup_0) {
  return [markup_0.id, markup_0];
}